import FileSaver from 'file-saver'
import { Form, Formik } from 'formik'
import moment from 'moment'
import React, { useState } from 'react'
import {
  Accordion,
  Badge,
  Button,
  Col,
  Offcanvas,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import IpCheckbox from '../../../components/IpCheckbox'
import CustomToast from '../../../components/Toast/CustomToast'
import {
  arrangeItemsByStatusAndPackage,
  arrangeOrderItems,
  encodeId,
  encodedSearchText,
  fetchOrderData,
  formatMRP,
  getInitials,
  groupItemsByPackage,
  showToast
} from '../../../lib/AllGlobalFunction'
import { _orderStatus_, currencyIcon } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { getBaseUrl, getDeviceId, getUserToken } from '../../../lib/GetBaseUrl'
import { _productImg_ } from '../../../lib/ImagePath'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import CancelOrder from './CancelOrder'
import ConfirmOrder from './ConfirmOrder'
import PackOrder from './PackOrder'
import ShipOrder from './ShipOrder'
import TrackOrder from './TrackOrder'

function OrderDetail({
  setOrderDetailModalShow,
  orderDetailModalShow,
  setLoading,
  getOrderItems,
  filterDetails
}) {
  const [modalShow, setModalShow] = useState({ show: false, data: null })
  const { userInfo } = useSelector((state) => state?.user)
  const location = useLocation()

  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  let initVal = {
    confirm: {
      warehouseId: null,
      orderId: null,
      orderItemId: null
    },
    pack: {
      orderID: null,
      orderItemIDs: [],
      totalItems: '',
      noOfPackage: '',
      packageAmount: '',
      wherehouseId: ''
    },
    ship: {
      length: '',
      width: '',
      height: '',
      weight: '',
      packageDescription: ''
    },
    cancel: {
      orderId: '',
      orderItemIds: '',
      newOrderNo: '',
      qty: '',
      actionID: '',
      action: '',
      userId: '',
      userName: '',
      userPhoneNo: '',
      userEmail: '',
      issue: '',
      reason: '',
      reasonID: '',
      comment: '',
      paymentMode: '',
      attachment: '',
      refundAmount: '',
      refundType: '',
      bankName: '',
      bankBranch: '',
      bankIFSCCode: '',
      bankAccountNo: '',
      accountType: '',
      accountHolderName: ''
    }
  }

  const [initialValues, setInitialValues] = useState(initVal)

  const prepareShippingData = (data) => {
    let userDetails = orderDetailModalShow?.data
    return {
      ...initialValues?.ship,
      sellerID: data?.sellerID,
      warehouseId: data?.wherehouseId,
      orderID: data?.orderID,
      orderItemIDs: data?.packageItemIds,
      packageID: data?.packageId,
      paymentMode: userDetails?.paymentMode,
      invoiceAmount: data?.packageAmount,
      invoiceCodCharges: data?.packageCodCharges,
      isShipmentInitiate: true,
      isPaymentSuccess: false,
      courierID: '',
      serviceID: '',
      serviceType: '',
      dropContactPersonName: userDetails?.userName,
      dropContactPersonMobileNo: userDetails?.userPhoneNo,
      dropContactPersonEmailID: userDetails?.userEmail,
      dropCompanyName: userDetails?.userName,
      dropAddressLine1: userDetails?.userAddressLine1,
      dropAddressLine2: userDetails?.userAddressLine2,
      dropLandmark: userDetails?.userLendMark,
      dropPincode: userDetails?.userPincode,
      dropCity: userDetails?.userCity,
      dropState: userDetails?.userState,
      dropCountry: userDetails?.userCountry,
      dropTaxNo: userDetails?.userGSTNo ?? '',
      shipmentID: '',
      shipmentOrderID: '',
      shippingPartner: 'System',
      courierName: '',
      shippingAmountFromPartner: 0,
      awbNo: '',
      isShipmentSheduledByAdmin: true,
      pickupLocationID: '',
      errorMessage: '',
      forwardLable: '',
      returnLable: ''
    }
  }

  return (
    <>
      <Offcanvas
        className='pv-offcanvas pv-order-preview-model'
        placement='end'
        show={orderDetailModalShow.show}
        backdrop='static'
        onHide={() => {
          setOrderDetailModalShow({
            show: !orderDetailModalShow?.show,
            data: null
          })
        }}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title className="bold">Order Detail</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='pv-orderpreview-detail'>
            <div className='pv-orderpreview-col'>
              <div className='d-flex justify-content-between justify-content-between flex-wrap align-items-center'>
                <div className='mb-0 cfz-18'>
                  Order Number :<b>{orderDetailModalShow?.data?.orderNo} </b>
                </div>
                <div className='d-flex align-items-center gap-3'>
                  <div className=' pv-order-status-main'>
                    <ul className='pv-order-status-col'>
                      <li>
                        <span className='pv-order-status-dot'></span>{' '}
                        <p> {orderDetailModalShow?.data?.status} </p>
                      </li>
                      <li>
                        <span className='pv-order-status-dot'></span>{' '}
                        <p> {orderDetailModalShow?.data?.paymentMode} </p>
                      </li>
                    </ul>
                  </div>
                  <div className='mb-0 cfz-18'>
                    Order Date : &nbsp;
                    <b>
                      {moment(orderDetailModalShow?.data?.orderDate).format(
                        'DD/MM/YYYY'
                      )}
                    </b>
                  </div>
                </div>
              </div>
            </div>
            <div className='pv-orderpreview-col'>
              <h4 className='fw-semibold cfz-18'>Order Details</h4>
              <Table className='align-middle table-view '>
                <tbody>
                  <tr className='pv-productd-remhover'>
                    <th className='text-nowrap fw-normal p-1'>Shipment by</th>
                    <td className='bold p-1 cfz-14'>
                      {' '}
                      {orderDetailModalShow?.data?.orderItems &&
                        orderDetailModalShow?.data?.orderItems[0]
                          ?.shippmentBy}{' '}
                    </td>
                  </tr>
                  <tr className='pv-productd-remhover'>
                    <th className='text-nowrap fw-normal p-1'>Ordered by</th>
                    <td className='bold p-1 cfz-14'>
                      {' '}
                      {orderDetailModalShow?.data?.orderBy}{' '}
                    </td>
                  </tr>
                  <tr className='pv-productd-remhover'>
                    <th className='text-nowrap fw-normal p-1'>Amount Paid</th>
                    <td className='bold p-1 cfz-14'>
                      {' '}
                      {currencyIcon}{' '}
                      {formatMRP(orderDetailModalShow?.data?.paidAmount)}{' '}
                    </td>
                  </tr>
                  <tr className='pv-productd-remhover'>
                    <th className='text-nowrap fw-normal p-1'>Coupon Code</th>
                    <td className='bold p-1 cfz-14'>
                      {' '}
                      {orderDetailModalShow?.data?.coupon
                        ? orderDetailModalShow?.data?.coupon
                        : '-'}{' '}
                    </td>
                  </tr>
                  <tr className='pv-productd-remhover'>
                    <th className='text-nowrap fw-normal p-1'>
                      Coupon Discount
                    </th>
                    <td className='bold p-1 cfz-14'>
                      {' '}
                      {currencyIcon}{' '}
                      {orderDetailModalShow?.data?.coupontDiscount}{' '}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div className='pv-orderpreview-col'>
              <h4 className='fw-semibold cfz-18'>Customer Details</h4>
              <div className='d-flex align-items-center gap-2 mb-4'>
                <div className='ch-31 cw-30 rounded badge-yellow d-flex align-items-center justify-content-center'>
                  <span>
                    {orderDetailModalShow?.data?.userName &&
                      getInitials(orderDetailModalShow?.data?.userName)}
                  </span>
                </div>
                <p className='mb-0'>{orderDetailModalShow?.data?.userName}</p>
              </div>
              <div className='d-flex gap-2 flex-column'>
                <div className='d-flex align-items-center gap-2'>
                  <i className='m-icon m-icon--mail'></i>
                  <span>{orderDetailModalShow?.data?.userEmail}</span>
                </div>
                <div className='d-flex align-items-center gap-2'>
                  <i className='m-icon m-icon--call'></i>
                  <span>+91 {orderDetailModalShow?.data?.userPhoneNo}</span>
                </div>
                <div className='d-flex align-items-center gap-2'>
                  <i className='m-icon m-icon--location'></i>
                  <span>
                    {orderDetailModalShow?.data?.userAddressLine1},{' '}
                    {orderDetailModalShow?.data?.userAddressLine2}
                    {orderDetailModalShow?.data?.userLendMark
                      ? `, ${orderDetailModalShow?.data?.userLendMark}`
                      : ''}
                    , {orderDetailModalShow?.data?.userCity}
                    {orderDetailModalShow?.data?.userPincode
                      ? `, ${orderDetailModalShow?.data?.userPincode}`
                      : ''}
                  </span>
                </div>
              </div>
            </div>
            {orderDetailModalShow?.data?.orderItems &&
              orderDetailModalShow?.data?.orderItems?.length > 0 && (
                <div className='pv-orderpreview-col'>
                  <h4 className='fw-semibold cfz-18'>Seller Details</h4>
                  <div className='d-flex align-items-center gap-2 mb-4'>
                    <div className='ch-31 cw-30 rounded badge-yellow d-flex align-items-center justify-content-center'>
                      <span>
                        {getInitials(
                          orderDetailModalShow?.data?.orderItems[0]?.sellerName
                        )}
                      </span>
                    </div>
                    <p className='mb-0'>
                      {orderDetailModalShow?.data?.orderItems[0]?.sellerName}
                    </p>
                  </div>
                  <div className='d-flex gap-2 flex-column'>
                    <div className='d-flex align-items-center gap-2'>
                      <i className='m-icon m-icon--mail'></i>
                      <span>
                        {
                          orderDetailModalShow?.data?.orderItems[0]
                            ?.sellerEmailId
                        }
                      </span>
                    </div>
                    {orderDetailModalShow?.data?.orderItems[0]
                      ?.sellerPhoneNo && (
                      <div className='d-flex align-items-center gap-2'>
                        <i className='m-icon m-icon--call'></i>
                        <span>
                          +91{' '}
                          {
                            orderDetailModalShow?.data?.orderItems[0]
                              ?.sellerPhoneNo
                          }
                        </span>
                      </div>
                    )}
                    {orderDetailModalShow?.data?.orderItems[0]?.sellerID && (
                      <div className='d-flex align-items-center gap-2 slide active'>
                        <i className='m-icon m-icon--sellers'></i>
                        <Link
                          to={`/manage-seller/seller-details/${encodeId(
                            orderDetailModalShow?.data?.orderItems[0]?.sellerID
                          )}`}
                        >
                          <span>View Seller Details </span>
                        </Link>
                      </div>
                    )}
                    {/* <div className='d-flex align-items-center gap-2'>
                      <i className='m-icon m-icon--location'></i>
                      <span>
                        {orderDetailModalShow?.data?.orderItems[0]?.userAddressLine1},{' '}
                        {orderDetailModalShow?.data?.orderItems[0]?.userAddressLine2}
                        {orderDetailModalShow?.data?.orderItems[0]?.userLendMark
                          ? `, ${orderDetailModalShow?.data?.orderItems[0]?.userLendMark}`
                          : ''}
                        , {orderDetailModalShow?.data?.orderItems[0]?.userCity}
                        {orderDetailModalShow?.data?.orderItems[0]?.userPincode
                          ? `, ${orderDetailModalShow?.data?.orderItems[0]?.userPincode}`
                          : ''}
                      </span>
                    </div> */}
                  </div>
                </div>
              )}
          </div>

          <Formik enableReinitialize initialValues={initialValues?.pack}>
            {({ values, setFieldValue }) => (
              <Form>
                <Row className='w-100 m-auto align-items-start mt-4'>
                  <Col md={12} className='ps-0'>
                    {orderDetailModalShow?.data?.orderItems &&
                      Array.from(
                        new Set(
                          orderDetailModalShow?.data?.orderItems?.map(
                            (item) => item?.sellerID
                          )
                        )
                      )?.map((sellerID) => (
                        <Accordion
                          className='pv-accordion-main mb-2'
                          defaultActiveKey={sellerID}
                        >
                          <Accordion.Item eventKey={sellerID}>
                            <Accordion.Header>
                              <div className='px-3 py-0 w-100 d-flex justify-content-end align-items-center'>
                                {/* <div className="col-md-4">
                                  <span className="cfz-14 badge bg-light-blue">
                                    Seller name:{" "}
                                    {
                                      orderDetailModalShow?.data?.orderItems?.find(
                                        (item) => item?.sellerID === sellerID
                                      )?.sellerName
                                    }
                                  </span>
                                </div> */}
                                <div>
                                  <p className='mb-0  badge bg-light-gry'>
                                    Total Items :{' '}
                                    {
                                      orderDetailModalShow?.data?.orderItems?.filter(
                                        (item) => item?.sellerID === sellerID
                                      )?.length
                                    }
                                  </p>
                                </div>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              {Object.values(
                                arrangeItemsByStatusAndPackage(
                                  arrangeOrderItems(
                                    orderDetailModalShow?.data?.orderItems
                                  )?.filter(
                                    (item) => item?.sellerID === sellerID
                                  )
                                )
                              )?.map((item) => {
                                return (
                                  <div className='pv-order-detailcard  border mt-3  mb-4 p-3 position-relative'>
                                    <span className='pv-order-status'>
                                      <Badge
                                        className={
                                          item[0]?.status ===
                                          _orderStatus_.placed
                                            ? 'badge bg-Placed'
                                            : item[0]?.status ===
                                              _orderStatus_.delivered
                                            ? 'badge bg-Delivered'
                                            : item[0]?.status ===
                                                _orderStatus_.cancelled ||
                                              item[0]?.status ===
                                                _orderStatus_.returned
                                            ? 'badge bg-Cancelled'
                                            : item[0]?.status ===
                                              _orderStatus_.confirmed
                                            ? 'badge bg-Confirmed'
                                            : 'badge bg-Returned'
                                        }
                                      >
                                        Item Status :&nbsp;{item[0]?.status}
                                      </Badge>
                                    </span>
                                    {item?.length > 0 &&
                                      Object.values(
                                        groupItemsByPackage(item)
                                      )?.map((data, index) => (
                                        <div
                                          key={Math.floor(
                                            Math.random() * 100000
                                          )}
                                        >
                                          {data?.map((data, index) => (
                                            <div
                                              key={Math.floor(
                                                Math.random() * 100000
                                              )}
                                            >
                                              <div className='d-flex align-items-center mb-3 w-100 m-auto'>
                                                <div className='mb-0 col-md-3'>
                                                  {data?.status ===
                                                    _orderStatus_.confirmed && (
                                                    <IpCheckbox
                                                      checked={
                                                        values?.orderItemIDs?.includes(
                                                          data?.id
                                                        )
                                                          ? true
                                                          : false
                                                      }
                                                      isDisabled={
                                                        values?.wherehouseId &&
                                                        data?.wherehouseId !==
                                                          values?.wherehouseId
                                                      }
                                                      checkboxLabel={
                                                        'Pack Item'
                                                      }
                                                      checkboxid={data?.id}
                                                      value={data?.id}
                                                      changeListener={(e) => {
                                                        let currentSeller =
                                                          values?.currentSeller
                                                            ? values?.currentSeller
                                                            : sellerID
                                                        if (
                                                          currentSeller ===
                                                          data?.sellerID
                                                        ) {
                                                          let orderItemIDs =
                                                            values?.orderItemIDs ||
                                                            []

                                                          if (e?.checked) {
                                                            orderItemIDs = [
                                                              ...orderItemIDs,
                                                              data?.id
                                                            ]
                                                          } else {
                                                            orderItemIDs =
                                                              orderItemIDs.filter(
                                                                (id) =>
                                                                  id !==
                                                                  data?.id
                                                              )
                                                          }

                                                          setFieldValue(
                                                            'orderItemIDs',
                                                            orderItemIDs
                                                          )
                                                          setFieldValue(
                                                            'currentSeller',
                                                            currentSeller
                                                          )
                                                          if (
                                                            e?.checked &&
                                                            values?.wherehouseId ===
                                                              ''
                                                          ) {
                                                            setFieldValue(
                                                              'wherehouseId',
                                                              data?.wherehouseId
                                                            )
                                                          } else {
                                                            setFieldValue(
                                                              'wherehouseId',
                                                              ''
                                                            )
                                                          }
                                                        } else {
                                                          Swal.fire({
                                                            title: 'Error',
                                                            text: 'You can only pack items from one seller at a time. Do you want to proceed with packing items from another seller?',
                                                            icon: 'error',
                                                            showCancelButton: true,
                                                            confirmButtonText:
                                                              'Yes, Proceed',
                                                            cancelButtonText:
                                                              'Cancel'
                                                          }).then((result) => {
                                                            if (
                                                              result.isConfirmed
                                                            ) {
                                                              currentSeller =
                                                                sellerID
                                                              let orderItemIDs =
                                                                []

                                                              if (e?.checked) {
                                                                orderItemIDs = [
                                                                  ...orderItemIDs,
                                                                  data?.id
                                                                ]
                                                              } else {
                                                                orderItemIDs =
                                                                  orderItemIDs.filter(
                                                                    (id) =>
                                                                      id !==
                                                                      data?.id
                                                                  )
                                                              }

                                                              setFieldValue(
                                                                'orderItemIDs',
                                                                orderItemIDs
                                                              )
                                                              setFieldValue(
                                                                'currentSeller',
                                                                currentSeller
                                                              )
                                                            }
                                                          })
                                                        }
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                                <div className='col-md-3 ms-auto'>
                                                  <div className='d-flex justify-content-end'>
                                                    <span
                                                      role='button'
                                                      className='badge bg-info '
                                                      onClick={async () => {
                                                        try {
                                                          setLoading(true)
                                                          const response =
                                                            await axiosProvider(
                                                              {
                                                                method: 'GET',
                                                                endpoint: `ManageOrder/OrderTrack?OrderID=${data?.orderID}&OrderItemID=${data?.id}&Isdeleted=false&PageIndex=1&PageSize=10`
                                                              }
                                                            )
                                                          setLoading(false)

                                                          if (
                                                            response?.status ===
                                                            200
                                                          ) {
                                                            setModalShow({
                                                              type: 'track-order',
                                                              show: !modalShow?.show,
                                                              data: response
                                                                ?.data?.data
                                                            })
                                                            setInitialValues({
                                                              ...initialValues,
                                                              confirm: {
                                                                ...initVal?.confirm,
                                                                orderItemId:
                                                                  data?.id,
                                                                orderId:
                                                                  data?.orderID
                                                              }
                                                            })
                                                          }
                                                        } catch {}
                                                      }}
                                                    >
                                                      Track Item
                                                    </span>
                                                    {/* <span>item Has Been Placed</span> */}
                                                  </div>
                                                </div>
                                              </div>

                                              <div className='row w-100 m-auto'>
                                                <div className='col-4'>
                                                  <div className='position-relative w-100 h-100'>
                                                    <img
                                                      className='h-100 w-100 img-object-fit-con position-absolute top-50 start-50 translate-middle'
                                                      src={`${process.env.REACT_APP_IMG_URL}${_productImg_}${data?.productImage}`}
                                                      alt={data?.productName}
                                                    />
                                                  </div>
                                                </div>
                                                <div className='col-8 p-0'>
                                                  {data?.productName && (
                                                    <p className='mb-1 cfz-18 bold'>
                                                      {data?.productName}
                                                    </p>
                                                  )}

                                                  <div className='d-flex gap-1 align-items-center justify-content-between'>
                                                    <div className='d-flex gap-1 align-items-center'>
                                                      <h3 className='cfz-17 mb-0 bold'>
                                                        {data?.sellingPrice}
                                                      </h3>
                                                      <span
                                                        type='button'
                                                        class='border px-2 py-1 cfz-13 rounded mb-0  badge bg-light-gry'
                                                      >
                                                        <span class='text-black h-100 cw-10 d-inline-block  bg-body-secondary bold'>
                                                          {data?.qty}
                                                        </span>
                                                        qty{' '}
                                                      </span>
                                                    </div>
                                                    <OverlayTrigger
                                                      trigger='click'
                                                      placement='bottom'
                                                      overlay={
                                                        <Popover
                                                          id={`popover-positioned-bottom`}
                                                        >
                                                          <Popover.Header as='h3'>{`Popover`}</Popover.Header>
                                                          <Popover.Body>
                                                            <strong>
                                                              Holy guacamole!
                                                            </strong>{' '}
                                                            Check this info.
                                                          </Popover.Body>
                                                        </Popover>
                                                      }
                                                    >
                                                      <span
                                                        role='button'
                                                        title='Click'
                                                      >
                                                        <i className='m-icon m-icon--exclamation-mark'></i>
                                                      </span>
                                                    </OverlayTrigger>
                                                  </div>
                                                  <div className='d-flex'>
                                                    <div className='col-md-6'>
                                                      {data?.productSKUCode && (
                                                        <div>
                                                          <span className='text-nowrap fw-normal p-0'>
                                                            SKU Code
                                                          </span>
                                                          <span className='p-0'>
                                                            :{' '}
                                                            <span className='bold'>
                                                              {
                                                                data?.productSKUCode
                                                              }
                                                            </span>
                                                          </span>
                                                        </div>
                                                      )}
                                                      {data?.sizeValue && (
                                                        <div>
                                                          <span className='text-nowrap fw-normal p-0'>
                                                            Size
                                                          </span>
                                                          <span className='p-0'>
                                                            :{' '}
                                                            <span className='bold'>
                                                              {data?.sizeValue}
                                                            </span>
                                                          </span>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <div className='col-md-6'>
                                                      {data?.brandName && (
                                                        <div>
                                                          <span className='text-nowrap fw-normal p-0'>
                                                            Brande
                                                          </span>
                                                          <span className='p-0'>
                                                            :{' '}
                                                            <span className='bold'>
                                                              {data?.brandName}
                                                            </span>
                                                          </span>
                                                        </div>
                                                      )}
                                                      {data?.color && (
                                                        <div>
                                                          <span className='text-nowrap fw-normal p-0'>
                                                            Color
                                                          </span>
                                                          <span className='p-0'>
                                                            :{' '}
                                                            <span className='bold'>
                                                              {data?.color}
                                                            </span>
                                                          </span>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div>
                                                {data?.orderWiseExtendedWarranty &&
                                                  data
                                                    ?.orderWiseExtendedWarranty[
                                                    index
                                                  ] && (
                                                    <div className='pv-orderwarranty-main mt-3 p-3 rounded'>
                                                      {data
                                                        ?.orderWiseExtendedWarranty?.[0] && (
                                                        <p className='cfz-18 mb-0 fw-bolder'>
                                                          {`Extended Warranty for
                                                              ${data?.orderWiseExtendedWarranty[0]?.title} (${data?.orderWiseExtendedWarranty[0]?.year} years)`}
                                                        </p>
                                                      )}
                                                      <div className='pv-warranty-cardmain'>
                                                        <h3 className='prdt_warranty_title cfz-16 fw-bolder'>
                                                          Secure Shopping with
                                                          Exclusive Warranty
                                                        </h3>
                                                        <p className='prdt_warranty_tips'>
                                                          {
                                                            data
                                                              ?.orderWiseExtendedWarranty[
                                                              index
                                                            ]?.SortDescription
                                                          }
                                                        </p>
                                                        <p className='prdt_warranty_tips'>
                                                          {
                                                            data
                                                              ?.orderWiseExtendedWarranty[
                                                              index
                                                            ]?.Description
                                                          }
                                                        </p>
                                                        <Table
                                                          border
                                                          className='pv-warranty-tablemain table-list w-100'
                                                        >
                                                          <thead>
                                                            <tr>
                                                              <th>Year</th>
                                                              <th>Price</th>
                                                              <th>Quantity</th>
                                                              <th>Total</th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            <tr>
                                                              <td>
                                                                {
                                                                  data
                                                                    ?.orderWiseExtendedWarranty[
                                                                    index
                                                                  ]?.year
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  data
                                                                    ?.orderWiseExtendedWarranty[
                                                                    index
                                                                  ]?.chargesIn
                                                                }
                                                              </td>

                                                              <td>
                                                                {
                                                                  data
                                                                    ?.orderWiseExtendedWarranty[
                                                                    index
                                                                  ]?.qty
                                                                }
                                                              </td>

                                                              <td>
                                                                {data
                                                                  ?.orderWiseExtendedWarranty[
                                                                  index
                                                                ]?.actualPrice *
                                                                  data
                                                                    ?.orderWiseExtendedWarranty[
                                                                    index
                                                                  ]?.qty}
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </Table>
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>
                                              <div className='d-flex gap-3 mt-3'>
                                                {data?.status ===
                                                  _orderStatus_.confirmed &&
                                                  !values?.orderItemIDs.includes(
                                                    data?.id
                                                  ) && (
                                                    <Button
                                                      onClick={async () => {
                                                        try {
                                                          setModalShow({
                                                            type: 'package',
                                                            show: !modalShow.show
                                                          })
                                                          setInitialValues({
                                                            ...initialValues,
                                                            pack: {
                                                              totalItems: 1,
                                                              packageAmount:
                                                                data?.subTotal,
                                                              orderID:
                                                                data?.orderID,
                                                              orderItemIDs:
                                                                data?.id?.toString(),
                                                              noOfPackage: ''
                                                            }
                                                          })
                                                        } catch {
                                                          setLoading(false)

                                                          showToast(
                                                            toast,
                                                            setToast,
                                                            {
                                                              data: {
                                                                message:
                                                                  _exception?.message,
                                                                code: 204
                                                              }
                                                            }
                                                          )
                                                        }
                                                      }}
                                                    >
                                                      Pack item
                                                    </Button>
                                                  )}

                                                {data?.status ===
                                                  _orderStatus_.placed && (
                                                  <Button
                                                    className='btn btn-primary'
                                                    onClick={async () => {
                                                      try {
                                                        setLoading(true)
                                                        const response =
                                                          await axiosProvider({
                                                            method: 'GET',
                                                            endpoint:
                                                              'Seller/Order/Getwarehouse',
                                                            queryString: `?sellerId=${data?.sellerID}&sellerProductId=${data?.sellerProductID}&productId=${data?.productID}&sizeId=${data?.sizeID}&quantity=${data?.qty}`
                                                          })
                                                        setLoading(false)

                                                        if (
                                                          response?.status ===
                                                          200
                                                        ) {
                                                          if (
                                                            response?.data?.data
                                                              ?.length > 0
                                                          ) {
                                                            setModalShow({
                                                              type: 'confirm-order',
                                                              show: !modalShow?.show,
                                                              data: response
                                                                ?.data?.data
                                                            })
                                                            setInitialValues({
                                                              ...initialValues,
                                                              confirm: {
                                                                ...initVal?.confirm,
                                                                orderItemId:
                                                                  data?.id?.toString(),
                                                                orderId:
                                                                  data?.orderID
                                                              }
                                                            })
                                                          } else {
                                                            Swal.fire({
                                                              title:
                                                                'No Available Warehouses',
                                                              text: `There are currently no warehouses available to fulfill ${data?.productName}`,
                                                              icon: 'info',
                                                              confirmButtonText:
                                                                'OK'
                                                            })
                                                          }
                                                        }
                                                      } catch {
                                                        setLoading(false)

                                                        showToast(
                                                          toast,
                                                          setToast,
                                                          {
                                                            data: {
                                                              message:
                                                                _exception?.message,
                                                              code: 204
                                                            }
                                                          }
                                                        )
                                                      }
                                                    }}
                                                  >
                                                    Assign Warehouse
                                                  </Button>
                                                )}

                                                {(data?.status ===
                                                  _orderStatus_.confirmed ||
                                                  data?.status ===
                                                    _orderStatus_.placed) && (
                                                  <Button
                                                    className='btn-red-light'
                                                    onClick={async () => {
                                                      setModalShow({
                                                        type: 'cancel-order',
                                                        show: !modalShow?.show
                                                      })

                                                      setInitialValues({
                                                        ...initialValues,
                                                        cancel: {
                                                          ...initVal?.cancel,
                                                          orderId:
                                                            data?.orderID,
                                                          orderItemIds:
                                                            data?.id?.toString(),
                                                          productName:
                                                            data?.productName,
                                                          newOrderNo: '',
                                                          qty: data?.qty,
                                                          actionID: '',
                                                          userId:
                                                            orderDetailModalShow
                                                              ?.data?.userId,
                                                          userName:
                                                            orderDetailModalShow
                                                              ?.data?.userName,
                                                          userPhoneNo:
                                                            orderDetailModalShow
                                                              ?.data
                                                              ?.userPhoneNo,
                                                          userEmail:
                                                            orderDetailModalShow
                                                              ?.data?.userEmail,
                                                          issue: '',
                                                          reason: '',
                                                          comment: '',
                                                          paymentMode:
                                                            orderDetailModalShow
                                                              ?.data
                                                              ?.paymentMode,
                                                          attachment: '',
                                                          refundAmount:
                                                            orderDetailModalShow
                                                              ?.data
                                                              ?.paidAmount,
                                                          refundType:
                                                            'Origin payment mode',
                                                          bankName: '',
                                                          bankBranch: '',
                                                          bankIFSCCode: '',
                                                          bankAccountNo: '',
                                                          accountType: '',
                                                          accountHolderName: ''
                                                        }
                                                      })
                                                    }}
                                                  >
                                                    Cancel item
                                                  </Button>
                                                )}
                                              </div>
                                            </div>
                                          ))}

                                          <div className='d-flex gap-4'>
                                            {data[0]?.status ===
                                              _orderStatus_.packed && (
                                              <Button
                                                onClick={async () => {
                                                  let ship =
                                                    prepareShippingData(data[0])
                                                  setInitialValues({
                                                    ...initialValues,
                                                    ship
                                                  })
                                                  setModalShow({
                                                    type: 'ship',
                                                    show: !modalShow.show
                                                  })
                                                }}
                                              >
                                                Ship Item
                                              </Button>
                                            )}
                                            {(data[0]?.status ===
                                              _orderStatus_.ship ||
                                              data[0]?.status ===
                                                _orderStatus_?.delivered) && (
                                              <Button
                                                onClick={async () => {
                                                  if (data[0]?.packageId) {
                                                    let downloadUrl = `${getBaseUrl()}/GenerateInvoice/GenerateInvoice?Packageid=${
                                                      data[0]?.packageId
                                                    }`
                                                    let headers = new Headers()
                                                    headers.append(
                                                      'Authorization',
                                                      `Bearer ${getUserToken()}`
                                                    )
                                                    headers.append(
                                                      'device_id',
                                                      `${getDeviceId()}`
                                                    )
                                                    setLoading(true)
                                                    fetch(downloadUrl, {
                                                      method: 'POST',
                                                      headers: headers
                                                    })
                                                      .then((response) => {
                                                        setLoading(false)
                                                        const blob =
                                                          response.blob()
                                                        return blob
                                                      })
                                                      .then((blob) => {
                                                        const customFileName = `${orderDetailModalShow?.data?.orderNo}.pdf`
                                                        FileSaver.saveAs(
                                                          blob,
                                                          customFileName
                                                        )
                                                      })
                                                  } else {
                                                    setLoading(false)
                                                    showToast(toast, setToast, {
                                                      data: {
                                                        message:
                                                          _exception?.message,
                                                        code: 204
                                                      }
                                                    })
                                                  }
                                                }}
                                              >
                                                Invoice
                                              </Button>
                                            )}

                                            {data[0]?.status ===
                                              _orderStatus_.ship && (
                                              <Button
                                                onClick={async () => {
                                                  if (data[0]?.packageId) {
                                                    let downloadUrl = `${getBaseUrl()}/GenerateInvoice/GenerateShippingLabel?Packageid=${
                                                      data[0]?.packageId
                                                    }`
                                                    let headers = new Headers()
                                                    headers.append(
                                                      'Authorization',
                                                      `Bearer ${getUserToken()}`
                                                    )
                                                    headers.append(
                                                      'device_id',
                                                      `${getDeviceId()}`
                                                    )
                                                    setLoading(true)
                                                    fetch(downloadUrl, {
                                                      method: 'POST',
                                                      headers: headers
                                                    })
                                                      .then((response) => {
                                                        setLoading(false)
                                                        const blob =
                                                          response.blob()
                                                        return blob
                                                      })
                                                      .then((blob) => {
                                                        const customFileName = `${orderDetailModalShow?.data?.orderNo}.pdf`
                                                        FileSaver.saveAs(
                                                          blob,
                                                          customFileName
                                                        )
                                                      })
                                                  } else {
                                                    setLoading(false)
                                                    showToast(toast, setToast, {
                                                      data: {
                                                        message:
                                                          _exception?.message,
                                                        code: 204
                                                      }
                                                    })
                                                  }
                                                }}
                                              >
                                                Generate Shipping label
                                              </Button>
                                            )}

                                            {data[0]?.status ===
                                              _orderStatus_.ship && (
                                              <Button
                                                onClick={async () => {
                                                  Swal.fire({
                                                    title: 'Confirm Delivery',
                                                    text: 'Has the item been successfully delivered?',
                                                    icon: 'question',
                                                    showCancelButton:
                                                      _SwalDelete.showCancelButton,
                                                    confirmButtonColor:
                                                      _SwalDelete.confirmButtonColor,
                                                    cancelButtonColor:
                                                      _SwalDelete.cancelButtonColor,
                                                    confirmButtonText:
                                                      'Yes, Confirm Delivery',
                                                    cancelButtonText:
                                                      'No, Keep Reviewing'
                                                  }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                      try {
                                                        setLoading(true)
                                                        const response =
                                                          await axiosProvider({
                                                            method: 'PUT',
                                                            endpoint:
                                                              'ManageOrder/OrderDelivered',
                                                            data: {
                                                              orderId:
                                                                data[0]
                                                                  ?.orderID,
                                                              orderItemIds:
                                                                data[0]
                                                                  ?.packageItemIds
                                                            },
                                                            userId:
                                                              userInfo?.userId,
                                                            location:
                                                              location.pathname
                                                          })
                                                        setLoading(false)

                                                        if (
                                                          response?.status ===
                                                          200
                                                        ) {
                                                          showToast(
                                                            toast,
                                                            setToast,
                                                            response
                                                          )

                                                          const order =
                                                            await fetchOrderData(
                                                              `?searchText=${encodedSearchText(
                                                                filterDetails?.searchText
                                                              )}&pageIndex=${
                                                                filterDetails?.pageIndex
                                                              }&pageSize=${
                                                                filterDetails?.pageSize
                                                              }`,
                                                              toast,
                                                              setToast
                                                            )

                                                          if (
                                                            order?.status ===
                                                            200
                                                          ) {
                                                            getOrderItems(
                                                              data[0]?.orderID,
                                                              order?.data?.data
                                                            )
                                                          }
                                                        } else {
                                                          showToast(
                                                            toast,
                                                            setToast,
                                                            {
                                                              data: {
                                                                message:
                                                                  _exception?.message,
                                                                code: 204
                                                              }
                                                            }
                                                          )
                                                        }
                                                      } catch {
                                                        setLoading(false)
                                                        showToast(
                                                          toast,
                                                          setToast,
                                                          {
                                                            data: {
                                                              message:
                                                                _exception?.message,
                                                              code: 204
                                                            }
                                                          }
                                                        )
                                                      }
                                                    }
                                                  })
                                                }}
                                              >
                                                Deliever item
                                              </Button>
                                            )}
                                          </div>
                                          <hr />
                                        </div>
                                      ))}
                                  </div>
                                )
                              })}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}
                  </Col>
                  {/* <Col md={4} className='pe-0'>
                    <div className='card p-3 mb-4'>
                      <h3>Order Details</h3>
                      <Table className='align-middle table-view '>
                        <tbody>
                          {orderDetailModalShow?.data?.deliveryDate && (
                            <tr className='pv-productd-remhover'>
                              <th className='text-nowrap fw-normal bold p-1'>
                                Delivery Date
                              </th>
                              <td className='bold p-1 cfz-14'>
                                :{' '}
                                {moment(
                                  orderDetailModalShow?.data?.deliveryDate
                                ).format('DD/MM/YYYY')}
                              </td>
                            </tr>
                          )}
                          {orderDetailModalShow?.data?.status && (
                            <tr className='pv-productd-remhover'>
                              <th className='text-nowrap fw-normal p-1'>
                                Status
                              </th>
                              <td className='bold p-1 cfz-14'>
                                :{' '}
                                <Badge
                                  className={
                                    orderDetailModalShow?.data?.status ===
                                    _orderStatus_.placed
                                      ? 'badge bg-info'
                                      : orderDetailModalShow?.data?.status ===
                                        _orderStatus_.delivered
                                      ? 'badge bg-success'
                                      : orderDetailModalShow?.data?.status ===
                                          _orderStatus_.cancelled ||
                                        orderDetailModalShow?.data?.status ===
                                          _orderStatus_.returned
                                      ? 'badge bg-danger'
                                      : 'badge bg-warning'
                                  }
                                >
                                  {orderDetailModalShow?.data?.status}
                                </Badge>
                              </td>
                            </tr>
                          )}
                          {orderDetailModalShow?.data?.coupon && (
                            <tr className='pv-productd-remhover'>
                              <th className='text-nowrap fw-normal p-1'>
                                Used Coupon
                              </th>
                              <td className='bold p-1 cfz-14'>
                                : {orderDetailModalShow?.data?.coupon}
                              </td>
                            </tr>
                          )}

                          {orderDetailModalShow?.data?.coupon && (
                            <tr className='pv-productd-remhover'>
                              <th className='text-nowrap fw-normal p-1'>
                                Coupon
                              </th>
                              <td className='bold p-1 cfz-14'>
                                : {orderDetailModalShow?.data?.coupon}
                              </td>
                            </tr>
                          )}
                          {orderDetailModalShow?.data?.paidAmount !== null &&
                            orderDetailModalShow?.data?.paidAmount !==
                              undefined &&
                            orderDetailModalShow?.data?.paidAmount !== '' && (
                              <tr className='pv-productd-remhover'>
                                <th className='text-nowrap fw-normal p-1'>
                                  Amount Paid
                                </th>
                                <td className='bold p-1 cfz-14'>
                                  : {orderDetailModalShow?.data?.paidAmount}
                                </td>
                              </tr>
                            )}
                          {orderDetailModalShow?.data?.paymentMode && (
                            <tr className='pv-productd-remhover'>
                              <th className='text-nowrap fw-normal p-1'>
                                Payment Mode
                              </th>
                              <td className='bold p-1 cfz-14 text-uppercase'>
                                :{' '}
                                <Badge
                                  className={
                                    orderDetailModalShow?.data?.paymentMode ===
                                    'cod'
                                      ? 'badge bg-danger'
                                      : 'badge bg-success'
                                  }
                                >
                                  {orderDetailModalShow?.data?.paymentMode}
                                </Badge>
                              </td>
                            </tr>
                          )}
                          <tr className='pv-productd-remhover'>
                            <th className='text-nowrap fw-normal p-1'>
                              Shipment By
                            </th>
                            <td className='bold p-1 cfz-14'>
                              :{' '}
                              {
                                orderDetailModalShow?.data?.orderItems?.[0]
                                  ?.shippmentBy
                              }
                            </td>
                          </tr>
                          {orderDetailModalShow?.data?.orderBy && (
                            <tr className='pv-productd-remhover'>
                              <th className='text-nowrap fw-normal p-1'>
                                Order By
                              </th>
                              <td className='bold text-capitalize p-1'>
                                :{' '}
                                <Badge className={'badge bg-warning'}>
                                  {orderDetailModalShow?.data?.orderBy}
                                </Badge>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col> */}
                  <Col md={12}>
                    <div className='d-flex justify-content-end gap-4'>
                      {values?.orderItemIDs?.length > 0 && (
                        <>
                          <Button
                            onClick={() => {
                              let packageAmount =
                                orderDetailModalShow?.data?.orderItems
                                  ?.filter((item) =>
                                    values?.orderItemIDs?.includes(item.id)
                                  )
                                  ?.reduce(
                                    (acc, curr) => acc + curr.subTotal,
                                    0
                                  )
                              let packageData = {
                                orderID: orderDetailModalShow?.data?.orderId,
                                orderItemIDs: values?.orderItemIDs?.join(','),
                                totalItems: values?.orderItemIDs?.length,
                                packageAmount
                              }
                              setInitialValues({
                                ...initialValues,
                                pack: {
                                  ...initialValues?.pack,
                                  ...packageData
                                }
                              })
                              setModalShow({
                                type: 'package',
                                show: !modalShow.show
                              })
                            }}
                          >
                            Pack order
                          </Button>
                          <Button
                            onClick={() => {
                              setFieldValue('orderItemIDs', [])
                              setFieldValue('wherehouseId', '')
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Offcanvas.Body>
      </Offcanvas>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {modalShow?.show && modalShow?.type === 'confirm-order' && (
        <ConfirmOrder
          modalShow={modalShow}
          setModalShow={setModalShow}
          getOrderItems={getOrderItems}
          setLoading={setLoading}
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          initVal={initVal}
          setToast={setToast}
          toast={toast}
          filterDetails={filterDetails}
        />
      )}

      {modalShow?.show && modalShow?.type === 'cancel-order' && (
        <CancelOrder
          modalShow={modalShow}
          setModalShow={setModalShow}
          getOrderItems={getOrderItems}
          setLoading={setLoading}
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          initVal={initVal}
          setToast={setToast}
          toast={toast}
          filterDetails={filterDetails}
        />
      )}

      {modalShow?.show && modalShow?.type === 'track-order' && (
        <TrackOrder modalShow={modalShow} setModalShow={setModalShow} />
      )}

      {modalShow?.show && modalShow?.type === 'package' && (
        <PackOrder
          modalShow={modalShow}
          setModalShow={setModalShow}
          getOrderItems={getOrderItems}
          setLoading={setLoading}
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          initVal={initVal}
          setToast={setToast}
          toast={toast}
          filterDetails={filterDetails}
        />
      )}

      {modalShow?.show && modalShow?.type === 'ship' && (
        <ShipOrder
          modalShow={modalShow}
          setModalShow={setModalShow}
          getOrderItems={getOrderItems}
          setLoading={setLoading}
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          initVal={initVal}
          setToast={setToast}
          toast={toast}
          filterDetails={filterDetails}
        />
      )}
    </>
  )
}

export default OrderDetail
